import {CheckBookingModalEnum} from 'presentation/modules/booking/health/ui/pages/HealthBooking/steps/HealthSpecialtySelection/components/HealthSpecialtiesList/hooks/useHealthSpecialtiesSelection/types';
import React, {useCallback, useEffect} from 'react';
import {UseBookingVerificationsProps} from './types';

const PENDING_DIALOG_STATES = new Set([
	CheckBookingModalEnum.VERIFYING_AUTH,
	CheckBookingModalEnum.VERIFYING_DUPLICITY,
	CheckBookingModalEnum.VERIFYING_DISTRICTS,
	CheckBookingModalEnum.VERIFYING_REQUEST_SCHEDULE,
]);

export function useBookingVerifications({
	checkBookingModal,
	setCheckBookingModal,
	resetBookingDataSpecialties,
	scheduledBooking,
	selectedProfessional,
}: UseBookingVerificationsProps) {
	const isPending = PENDING_DIALOG_STATES.has(checkBookingModal as CheckBookingModalEnum);
	const showDuplicityDialog =
		checkBookingModal === CheckBookingModalEnum.DUPLICITY_STATE && scheduledBooking;
	const isScriptState = checkBookingModal === CheckBookingModalEnum.SCRIPT_STATE;
	const showTherapyAlert = checkBookingModal === CheckBookingModalEnum.NEED_AUTH;
	const unexpectedErrorState = checkBookingModal === CheckBookingModalEnum.ERROR;
	const [openConfirmationDrawer, setOpenConfirmationDrawer] = React.useState(false);
	const [duplicityModalWasOpened, setDuplicityModalWasOpened] = React.useState(false);
	const [isConfirmingPending, setIsConfirmingPending] = React.useState(false);

	const handleClose = useCallback(() => {
		resetBookingDataSpecialties();
		setCheckBookingModal(CheckBookingModalEnum.NONE);
	}, [resetBookingDataSpecialties, setCheckBookingModal]);

	useEffect(() => {
		if (
			!isPending &&
			!unexpectedErrorState &&
			selectedProfessional &&
			(!scheduledBooking ||
				Number(scheduledBooking?.specialtyCode) !== selectedProfessional?.cdEspecialidade)
		) {
			setOpenConfirmationDrawer(true);
		}
	}, [isPending, unexpectedErrorState, selectedProfessional, scheduledBooking]);

	useEffect(() => {
		if (showDuplicityDialog && !duplicityModalWasOpened) {
			setDuplicityModalWasOpened(true);
		}
	}, [showDuplicityDialog, duplicityModalWasOpened]);

	return {
		isPending,
		showDuplicityDialog,
		isScriptState,
		showTherapyAlert,
		unexpectedErrorState,
		openConfirmationDrawer,
		setOpenConfirmationDrawer,
		duplicityModalWasOpened,
		setDuplicityModalWasOpened,
		isConfirmingPending,
		setIsConfirmingPending,
		handleClose,
	};
}
